import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RoutingFile from './RoutingFile';
import reportWebVitals from './reportWebVitals';
import { HashRouter as Router } from 'react-router-dom'; // ✅ HashRouter for SPA
import { HelmetProvider } from 'react-helmet-async'; // ✅ For SEO meta tags
import BookingForm from './BookingForm';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <Router>
      {/* <BookingForm/> */}
      <RoutingFile />
    </Router>
  </HelmetProvider>
);

reportWebVitals();
